import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public hook — reads the current owner-set live override state.
// Refreshes on the same `ool:live-override-changed` event that the owner panel emits.
export const useLiveOverride = (intervalMs = 60000) => {
    const [state, setState] = useState("auto"); // "auto" | "live" | "offline"

    useEffect(() => {
        let mounted = true;
        const fetchIt = async () => {
            try {
                const { data } = await axios.get(`${API}/twitch/live-override`, { timeout: 6000 });
                if (mounted) setState((data && data.state) || "auto");
            } catch {
                if (mounted) setState("auto");
            }
        };
        fetchIt();
        const timer = setInterval(fetchIt, intervalMs);
        const onChange = (e) => {
            const next = e?.detail?.state;
            if (next === "auto" || next === "live" || next === "offline") setState(next);
            else fetchIt();
        };
        window.addEventListener("ool:live-override-changed", onChange);
        return () => {
            mounted = false;
            clearInterval(timer);
            window.removeEventListener("ool:live-override-changed", onChange);
        };
    }, [intervalMs]);

    return state;
};
